import { initSentryClient } from '@ramp106/sentry/client'

import { useRuntimeConfig } from '#imports'

const {
  public: { version, env, sentryDsn },
} = useRuntimeConfig()

initSentryClient({
  dsn: sentryDsn,
  environment: env,
  release: version,
  replay: true,
})
